var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFiSrLayers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "m22.485 10.976-10.484 6.291-10.486-6.291A1 1 0 0 0 .486 12.69l11 6.6a1 1 0 0 0 1.03 0l11-6.6a1 1 0 1 0-1.028-1.714h-.003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#AAB3BE",
    d: "m22.485 15.543-10.484 6.29-10.486-6.29a.999.999 0 1 0-1.029 1.715l11 6.6a1 1 0 0 0 1.03 0l11-6.6a1 1 0 0 0-1.028-1.715h-.003Zm-22-7.185 9.984 5.99a2.97 2.97 0 0 0 3.062 0l9.984-5.99a1 1 0 0 0 0-1.714L13.53.653a2.973 2.973 0 0 0-3.062 0L.485 6.643a1 1 0 0 0 0 1.715Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiSrLayers);
export default __webpack_public_path__ + "static/media/fi-sr-layers.3e5b320c54a86d04bf855713721fc648.svg";
export { ForwardRef as ReactComponent };